var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_1516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 7.91664L1.66699 9.99997L9.70218 14.0176C9.8115 14.0722 9.86616 14.0996 9.92349 14.1103C9.97427 14.1198 10.0264 14.1198 10.0772 14.1103C10.1345 14.0996 10.1892 14.0722 10.2985 14.0176L18.3337 9.99997L14.167 7.91664M5.83366 12.0833L1.66699 14.1666L9.70218 18.1842C9.8115 18.2389 9.86616 18.2662 9.92349 18.277C9.97427 18.2865 10.0264 18.2865 10.0772 18.277C10.1345 18.2662 10.1892 18.2389 10.2985 18.1842L18.3337 14.1666L14.167 12.0833M1.66699 5.83331L9.70218 1.81571C9.8115 1.76105 9.86616 1.73372 9.92349 1.72297C9.97427 1.71344 10.0264 1.71344 10.0772 1.72297C10.1345 1.73372 10.1891 1.76105 10.2985 1.81571L18.3337 5.83331L10.2985 9.8509C10.1891 9.90556 10.1345 9.93289 10.0772 9.94365C10.0264 9.95317 9.97427 9.95317 9.92349 9.94365C9.86616 9.93289 9.8115 9.90556 9.70218 9.8509L1.66699 5.83331Z",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimFile);
export default __webpack_public_path__ + "static/media/claim-file.e3ab7b97bb663d87910207e24555b8e4.svg";
export { ForwardRef as ReactComponent };